import { DEFAULT_STATE } from '../constants'

export const initialThreeDPrintOnlyState = {
  withMakes: DEFAULT_STATE.withMakes,
  threeDPrintVerified: DEFAULT_STATE.threeDPrintVerified,
  preSupported: DEFAULT_STATE.preSupported,
  multipleParts: DEFAULT_STATE.multipleParts,
}
